import React from 'react';

/**
 * Message Modal Component
 * Displays a simple message dialog (success, error, warning, info)
 */
const MessageModal = ({ isOpen, onClose, title, message, type = 'info' }) => {
  if (!isOpen) return null;

  const colors = {
    success: {
      icon: '✅',
      iconColor: '#00FFB3',
      titleColor: '#00FFB3',
      borderColor: 'rgba(0, 255, 179, 0.3)'
    },
    error: {
      icon: '❌',
      iconColor: '#FF5757',
      titleColor: '#FF5757',
      borderColor: 'rgba(255, 87, 87, 0.3)'
    },
    warning: {
      icon: '⚠️',
      iconColor: '#FFC107',
      titleColor: '#FFC107',
      borderColor: 'rgba(255, 193, 7, 0.3)'
    },
    info: {
      icon: 'ℹ️',
      iconColor: '#00C2FF',
      titleColor: '#00C2FF',
      borderColor: 'rgba(0, 194, 255, 0.3)'
    }
  };

  const currentColors = colors[type] || colors.info;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)'
      }}
      onClick={onClose}
      data-testid="message-modal"
    >
      <div 
        style={{
          background: 'linear-gradient(135deg, #1A1E2E 0%, #242A3D 100%)',
          borderRadius: '16px',
          padding: '32px',
          maxWidth: '480px',
          width: '90%',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
          border: `2px solid ${currentColors.borderColor}`,
          animation: 'slideIn 0.3s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div 
            style={{
              fontSize: '56px',
              marginBottom: '16px',
              filter: 'drop-shadow(0 0 15px currentColor)',
              color: currentColors.iconColor
            }}
          >
            {currentColors.icon}
          </div>
          <h3 
            style={{
              fontSize: '22px',
              fontWeight: '700',
              color: currentColors.titleColor,
              marginBottom: '12px',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
            }}
            data-testid="message-modal-title"
          >
            {title}
          </h3>
          <p 
            style={{
              fontSize: '16px',
              color: '#FFFFFF',
              lineHeight: '1.6',
              whiteSpace: 'pre-line'
            }}
            data-testid="message-modal-message"
          >
            {message}
          </p>
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '14px 24px',
            borderRadius: '12px',
            border: 'none',
            background: `linear-gradient(135deg, ${currentColors.iconColor} 0%, ${currentColors.titleColor} 100%)`,
            color: '#1A1E2E',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = `0 8px 20px ${currentColors.borderColor}`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '';
          }}
          data-testid="message-modal-ok-btn"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default MessageModal;
